import React from "react";
import adenikeAkinode from "../../assets/staff/CommunityHealth/adenike_akinode.jpg";
import oluwoleFayemi from "../../assets/staff/CommunityHealth/oluwole_fayemi.jpg";
import taofeekBasiru from "../../assets/staff/CommunityHealth/taofeek_basiru.jpg";
import salomeAbbah from "../../assets/staff/CommunityHealth/salome_abbah.jpg";
import taiwoAdedoja from "../../assets/staff/CommunityHealth/taiwo_adedoja.jpg";
import preciousAshue from "../../assets/staff/CommunityHealth/precious_ashue.jpg";
import yewandeIdowu from "../../assets/staff/CommunityHealth/yewande_idowu.jpg";
import elizabethDavidOgedege from "../../assets/staff/CommunityHealth/elizabeth_david-ogedegbe.jpg";
import chinyereAdudike from "../../assets/staff/CommunityHealth/chiyere_adudike.jpg";
import bukolaAkingbola from "../../assets/staff/CommunityHealth/bukola_akingbola.jpg";
import hannahAkinbola from "../../assets/staff/CommunityHealth/hannah_akinbola.jpg";
import AlakaYusufAfusatAbosede from "../../assets/staff/Default/female.jpg";
import benedictKaralolo from "../../assets/staff/CommunityHealth/benedict_karalolo.jpg";
import idayatTiamiyuRasaq from "../../assets/staff/CommunityHealth/idayat_tiamiyu-rasaq.jpg";
import olajumokeOdewale from "../../assets/staff/CommunityHealth/olajumoke_odewale.jpg";

const CommunityHealthStaff = [
  {
    name: "AKINODE ADENIKE CHRISTIANA",
    designation: "Assistant Director/Coordinator",
    qualification: "RN 1990, RM 1994, CHO 2007, PHC TUTOR 2017, BNSc. 2021, MPH 2025.",
    photo: adenikeAkinode,
  },
  {
    name: "FAYEMI OLUWOLE ",
    designation: "Primary Health Care Tutor",
    qualification: "CHEW 1996, CHO 2014,PHC TUTOR 2018, BSc Health Sc.(Ed.) 2005, MPH 2018, PhD  Public Health in view.",
    photo: oluwoleFayemi,
    },
  {
    name: "BASIRU TAOFEEK ADEKOLA",
    designation: "Primary Health Care Tutor",
    qualification: "CHEW2002,CHO2013,BCHS in view,BSc Public Health2019,PHC Tutor2016, MPH2022,  PhD Comm. Health in view",
    photo: taofeekBasiru,
  },
  {
    name: "ABBAH SALOME CHIBUZOR",
    designation: "Primary Health Care Tutor",
    qualification: "CHEW2011, CHO2019, BCHS2025, MSc. Comm. Health2024,PhD Comm. Health in view",
    photo: salomeAbbah,
  },
  {
    name: "ADEDOJA TAIWO BLESSING",
    designation: "Community Health Officer's Tutor II",
    qualification: "BSc Public Health,2021/ MPH in view",
    photo: taiwoAdedoja,
  },
  {
    name: "ASHUE PRECIOUS USHIBENYIN",
    designation: "Community Health Officer's Tutor II",
    qualification: "BSc Public Health,2021/ MPH in view",
    photo: preciousAshue,
  },
  {
    name: "IDOWU YEWANDE SUZAN",
    designation: "Community Health Officer",
    qualification: "BSc Public Health, 2023 ",
    photo: yewandeIdowu,
  },
{
    name: "DAVID-OGEDEGBE ELIZABETH ABIMBOLA",
    designation: "Chief Community Technician",
    qualification: "PHC Tutor, BCHS, BSc Public Health (in view) CHO, CHEW.",
    photo: elizabethDavidOgedege,
},
{
    name: "ADUDIKE CHINYERE AGNES",
    designation: "Confidential Secretary I",
    qualification: "HND Office Technology and Management 2012.",
    photo: chinyereAdudike,  
},
{
    name: "AKINGBOLA ENITAN BUKOLA",
    designation: "Principal Executive Officer",
    qualification: "OND Bus Admin2006.",
    photo: bukolaAkingbola, 
},
{
    name: "AKINBOLA OMOBOLANLE HANNAH",
    designation: "Chief Clerical Officer",
    qualification: "OND Bus Admin2007, HND maketing2013",
    photo: hannahAkinbola,
},
{
    name: "ALAKA-YUSUF AFUSAT ABOSEDE",
    designation: "Locum Community Health Officer's II",
    qualification: "CHEW 2000, CHO 2014,PHC TUTOR 2021, BSc Public Health 2020, MPH2022, PhD in view.",
    photo: AlakaYusufAfusatAbosede,
},
{
    name: "KARALOLO BENEDICT BERABARI-AGE",
    designation: " PHC Tutor",
    qualification: "CHEW 2015, CHO 2019,PHC TUTOR 2023, BSc Public Health 2023,MSc Community Health in view",
    photo: benedictKaralolo, 
},
{
    name: "TIAMIYU-RASAQ IDAYAT ADEJOKE",
    designation: "Locum PHC Tutor",
    qualification: "CHEW 2015, CHO 2019,PHC TUTOR 2023, BSc Public Health 2023,MPH, PhD in view.",
    photo: idayatTiamiyuRasaq,
},

{
    name: "ODEWALE OLAJUMOKE SELIMOT",
    designation: "Locum Clerical Officer II",
    qualification: "O'LEVEL 2012",
    photo: olajumokeOdewale, 
}
];

export default CommunityHealthStaff;